module.exports = __webpack_public_path__ + "static/white-iron-greatsword-54574b1dc0f969ec01b349fab55bbf95.png";